import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import {ReportService} from "./interceptors/report.service";
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { ErrorDialogService } from './interceptors/modal/error-dialog.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	isProduction: boolean = environment.production;
	constructor(private oauthService: OAuthService, private reportService: ReportService,
		private errorDialogService: ErrorDialogService, private zone: NgZone
	) {}

	sendReports(): void {		
		// this.reportService.sendReport();	
		
		let msg: string = "Send report was triggered!";
		  let businessError = { message: msg, errorCode: "REPORT"};
		  this.zone.run(() => this.errorDialogService.openDialog(businessError));
	}

	logout(): void {
		console.info(`App.component before oauthService logout`);
		this.oauthService.logOut();
		console.info(`App.component after oauthService logout`);
		window.location.href = window.location.origin;
		console.info(`App.component after window.location.href`);
	}

	logIn(): void {
		console.info(`App.component before oauthService login`);
		this.oauthService.loadDiscoveryDocumentAndLogin().then(() => {
			console.log('App.component login completed', this.oauthService.hasValidAccessToken);
		});
		// console.info(`App.component after oauthService logout`);
		// window.location.href = window.location.origin;
		// console.info(`App.component after window.location.href`);
	}

	isLoggedIn(): boolean {
		return this.oauthService.hasValidAccessToken();
	}
}
